import styled from '@emotion/styled';
import Banner from 'patient-ping-remedy/packages/banner';

export const FieldWrapper = styled.div`
  margin-top: 1.6rem;
`;

export const StyledBanner = styled(Banner)`
  margin-bottom: 1.6rem;
`;
